
import { useZstdSrch } from 'mainpage/toparea/srchinput/useZstdSrch';
import { useCallback } from 'react';
import svcs from 'services';
import { RECENT_SEARCH_VALUE_STORAGE_KEY } from 'util/LocalStorageWrapper';

export const useRcentSearch = (): [string[], (v: string) => void] => {
  const { recents, setRecents } = useZstdSrch();

  const addRecent = useCallback(
    (recent: string) => {
      if ((recent || '').trim() === '') return; // empty string ignore
      const a = [recent, ...(recents || []).filter((r) => r !== recent)];
      const newRecents = a.slice(0, 5);
      setRecents(newRecents);
      svcs.localStorage.setItem(RECENT_SEARCH_VALUE_STORAGE_KEY, newRecents.toString());
    },
    [setRecents, recents]
  );

  return [recents, addRecent];
};
